import script from "./HousekeepingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HousekeepingModal.vue?vue&type=script&setup=true&lang=js"

import "./HousekeepingModal.vue?vue&type=style&index=0&id=22b37f8c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b37f8c"]])

export default __exports__